import { useSession } from "@src/data/session/UserSessionContext";
import { ReactElement } from "react";
import { Navigate } from "react-router-dom";

export type QuestionnaireAdminRouteProps = {
  children: ReactElement;
};

export function QuestionnaireAdminRoute({
  children,
}: QuestionnaireAdminRouteProps) {
  const session = useSession();

  if (!session.endyaAdmin) return <Navigate to="/" replace />;

  return children;
}
